// extracted by mini-css-extract-plugin
module.exports = {"container":"LiveBadge_container__3Bysl","circle":"LiveBadge_circle__22Kx7","flickerAnimation":"LiveBadge_flickerAnimation__2bU22"};